import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import {
  DanceManagerHttpService,
  DanceSchoolStateService,
  UserHttpService,
  UserTicketStateService
} from '@platri/dfx-angular-core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'df-contact-participants-dialog',
  templateUrl: './contact-participants-dialog.component.html',
  styleUrls: ['./contact-participants-dialog.component.scss'],
})
export class ContactParticipantsDialogComponent implements OnInit, OnDestroy {

  eventId: string;
  messageForm: FormGroup;
  readonly maxLength = 2000;

  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private readonly userHttpService: UserHttpService,
    private readonly userTicketService: UserTicketStateService,
    private danceManagerHttpService: DanceManagerHttpService,
    private danceSchoolService: DanceSchoolStateService,
    private translocoService: TranslocoService,
    private dialogRef: MatDialogRef<ContactParticipantsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.messageForm = this.fb.group({
      message: ['', [Validators.required, Validators.maxLength(this.maxLength)]]
    });
  }

  ngOnInit(): void {
    this.eventId = this.data.eventId;
  }
  
  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  send(): void {
    if (this.messageForm.valid) {
      // TODO: Implement sending logic with this.messageForm.get('message').value
      this.dialogRef.close(this.messageForm.get('message').value);
    }
  }
}
